import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import type React from 'react';
import { NAVY, RADIUS_ITEM, SURFACE_CONTAINER_LOWEST } from 'styles/tokens';

import type { NumericRangeFilterValue } from '../smartFilterTypes';

interface MinMaxInputsProps {
  value: NumericRangeFilterValue | null;
  onChange: (value: NumericRangeFilterValue) => void;
}

const INPUT_SX = {
  width: 90,
  '& .MuiOutlinedInput-root': {
    height: 36,
    borderRadius: RADIUS_ITEM,
    backgroundColor: SURFACE_CONTAINER_LOWEST,
    fontFamily: 'Jost, sans-serif',
    fontSize: '0.85rem',
  },
  '& .MuiInputLabel-root': {
    fontFamily: 'Jost, sans-serif',
    transform: 'translate(14px, 7px)',
    '&.Mui-focused, &.MuiFormLabel-filled': {
      transform: 'translate(14px, -9px) scale(0.75)',
    },
  },
} as const;

const MinMaxInputs: React.FC<MinMaxInputsProps> = ({ value, onChange }) => {
  const current = value ?? { min: null, max: null };

  const handleMin = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value;
    onChange({ ...current, min: raw === '' ? null : Number(raw) });
  };

  const handleMax = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value;
    onChange({ ...current, max: raw === '' ? null : Number(raw) });
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <TextField size="small" type="number" label="Min" value={current.min ?? ''} onChange={handleMin} sx={INPUT_SX} />
      <Typography sx={{ color: `${NAVY}60`, fontFamily: 'Jost, sans-serif', fontSize: '0.8rem' }}>—</Typography>
      <TextField size="small" type="number" label="Max" value={current.max ?? ''} onChange={handleMax} sx={INPUT_SX} />
    </Box>
  );
};

export default MinMaxInputs;
